module.exports = __webpack_public_path__ + "img/gsb46.fb7f97bd.png";